// extracted by mini-css-extract-plugin
module.exports = {"Home__content":"tOHB","Home__current_issue":"jwVm","Home__teasers":"n97A"};